import React from "react";
import Torta from "./PieChartComponent";
import Nota from "./QualChartComponent";
import Barra from "./BarChartComponent";

function GraphicType(datos, type) {
  switch (type) {
    case "torta":
      return <Torta data={datos} />;
    case "mas":
    case "doble":
    case "barras":
      return <Barra data={datos} />;
    case "nota":
      return <Nota data={datos} />;
    default:
      return <></>;
  }
}

function GenericComponent(props) {
  console.log(props)
  // if(!props.result.length) return <></>
  return (
    <>
      <div className="container-general-inform">
        <div></div>
        <div className="div-titulo-informes text-center">{props.title}</div>
      </div>
      {props.isCalificacion && (
        <div className="line line-100 align-center titleInform landing-titleInform title-page-inform-label">
          Como califica la imagen de :
        </div>
      )}
      <div class=" grid-graphics-perception-container-1-2 line line-100">
        <div class="line line-100">
          {props.result.map((dato, indice) => {
            return dato[0].pregunta.includes("OTRO-") ||
              dato[0].pregunta.includes("¿ POR QUE ?") ? (
              <React.Fragment key={"data-key-graphic-" + indice}></React.Fragment>
            ) : (
              <React.Fragment key={"data-key-graphic-" + indice}>
                {dato[0].chart === "nota" ? (
                  <>
                    <div className="line line-100">
                      <div className="line line-5"></div>
                      <div className="line line-90">
                        {GraphicType(dato, dato[0].chart)}
                      </div>
                      <div className="line line-5"></div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="line line-30 ">
                      <div className="line line-5"></div>
                      <div className="line line-90">
                        {GraphicType(dato, dato[0].chart)}
                      </div>
                      <div className="line line-5"></div>
                    </div>
                  </>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default GenericComponent;
